import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    loading: false,
    loaded: false,
};

const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        setPermissions(state, action) {
            state.list = action.payload || [];
            state.loaded = true;
        },

        clearPermissions(state) {
            state.list = [];
            state.loaded = false;
        },
    },
});

export const {
    setPermissions,
    clearPermissions,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
